import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type ConfirmDialogProps = {
  open: boolean;
  title: string;
  message: React.ReactNode;
  loading?: boolean;
  confirmLabel?: string;
  loadingLabel?: string;
  confirmColor?: "error" | "primary" | "secondary" | "success" | "warning" | "info";
  onCancel: () => void;
  onConfirm: () => void;
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  loading = false,
  confirmLabel = "Delete",
  loadingLabel = "Deleting...",
  confirmColor = "error",
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onCancel} PaperProps={{ sx: { borderRadius: "14px" } }}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button variant="contained" color={confirmColor} onClick={onConfirm} disabled={loading}>
        {loading ? loadingLabel : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
